module.exports = __webpack_public_path__ + "static/media/tara.f7409bc2.jpg";